import React from "react";
import { icons } from "../../constants";

/** Contenido del tooltip de causas (ejecución de importaciones) - reutilizable en tabla y modal */
const CAUSES_GROUPS = [
  {
    color: "#3C763D",
    items: [
      "P1 Proveedor internacional - Retraso en la producción del proveedor",
      "P2 Proveedor internacional - Falta de inventario del producto en origen",
      "P3 Proveedor internacional - Documentación incompleta o errónea (factura, CoA, etc.)",
      "P4 Proveedor internacional - Incumplimiento en la fecha de despacho",
    ],
  },
  {
    color: "#8A38F5",
    items: [
      "L1 Logística internacional - No disponibilidad de espacios en transporte (aéreo/marítimo)",
      "L2 Logística internacional - Contingencias internacionales (conflictos, huelgas, etc.)",
      "L3 Logística internacional - Congestión en puertos o aeropuertos",
      "L4 Logística internacional - Errores por parte del operador logístico",
    ],
  },
  {
    color: "#42A5F5",
    items: [
      "A1 Aduana - Demora en aprobación del registro o licencia de importación",
      "A2 Aduana - Observaciones o requerimientos de la autoridad aduanera",
      "A3 Aduana - Error en la documentación de nacionalización",
      "A4 Aduana - Demoras en la actuación de la agencia de intermediación aduanera",
    ],
  },
  {
    color: "#56AB91",
    items: [
      "N1 Normatividad - Registro sanitario sin vigencia o en proceso de renovación",
      "N2 Normatividad - Cambios en requisitos arancelarios o actualización de subpartidas",
      "N3 Normatividad - Cambios regulatorios inesperados en países exportadores",
      "N4 Normatividad - Demora o rechazo en revisión documental electrónica por inconsistencias",
    ],
  },
  {
    color: "#F97316",
    items: [
      "I1 Internas - Falta de flujo de caja para ejecutar pagos",
      "I2 Internas - Demora en la programación del transporte",
      "I3 Internas - Demora en la aprobación o generación de orden de compra",
      "I4 Internas - Descoordinación entre áreas",
      "I5 Internas - Error humano o desconocimiento de procedimiento",
      "I6 Internas - Priorización de otros productos",
      "I7 Internas - Suficiente stock en bodega",
    ],
  },
  {
    color: "#31708F",
    items: [
      "F1 Factores externos - Emergencias sanitarias, climáticas o naturales",
      "F2 Factores externos - Fallas en plataformas oficiales (DIAN, VUCE, ICA, etc.)",
      "F3 Factores externos - Cambios repentinos en normativas internacionales",
      "F4 Factores externos - Variabilidad abrupta en la tasa de cambio que impacta decisiones de compra",
    ],
  },
];

export const getCausesTooltipContent = () => (
  <div
    style={{
      maxWidth: "850px",
      maxHeight: "400px",
      overflowY: "auto",
      padding: "12px 16px",
      lineHeight: "1.5",
      whiteSpace: "normal",
    }}
  >
    {CAUSES_GROUPS.map((group, index) => (
      <div key={index} style={{ marginBottom: "10px" }}>
        {group.items.map((text, idx) => {
          const parts = text.split("-");
          const coloredText = parts[0].trim();
          const restText = parts.slice(1).join("-").trim();
          return (
            <div
              key={idx}
              style={{
                display: "flex",
                alignItems: "flex-start",
                fontSize: "13px",
                marginBottom: "4px",
              }}
            >
              <span
                style={{
                  backgroundColor: group.color,
                  color: "#fff",
                  fontWeight: "600",
                  padding: "2px 8px",
                  borderRadius: "4px",
                  marginRight: "8px",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                }}
              >
                {coloredText}
              </span>
              <span style={{ color: "#222", flex: 1 }}>{restText}</span>
            </div>
          );
        })}
      </div>
    ))}
  </div>
);

export const getTooltipImportRegistrationExpiration = (
  list = [],
  openModal,
  closeTooltip
) => {
  if (!Array.isArray(list) || list.length === 0) {
    return (
      <div>
        <p className="create-label">Información no disponible</p>
      </div>
    );
  }

  return (
    <div>
      {list.map((register) => {
        const days = Number(register.days_left);
        let color = "bg-gray";

        if (days <= 10) color = "bg-red";
        else if (days <= 20) color = "bg-yellow";

        const text =
          days < 0
            ? `Vencido hace ${Math.abs(days)} días`
            : days === 0
            ? "Vence hoy"
            : `${days} días para vencimiento`;

        const dayContent =
          days < 0 ? (
            <>
              <div className="IVContainer J-center">
                <div>{`Vencido hace`}</div>
                <strong>{`${Math.abs(days)} días`}</strong>
              </div>
            </>
          ) : days === 0 ? (
            <div>Vence hoy</div>
          ) : (
            <>
              <div className="IVContainer J-center">
                <strong>{days} días</strong>
                <div>Para vencimiento</div>
              </div>
            </>
          );

        return (
          <div
            key={register.id ?? register.registration_number}
            className="HContainer j-space-between mt-5"
          >
            <div className="IVContainer w-130">
              <p className="brand-text mayus">{register.supplier_name + " "}</p>
              <p className="brand-text">{register.product}</p>
            </div>
            <div className="IHContainer">
              <div className={`day-count-container ${color}`}>{dayContent}</div>
              <div
                className={`eye-btn font-size-9 `}
                onClick={() => {
                  closeTooltip();
                  openModal(register);
                }}
                style={{
                  pointerEvents: "auto",
                  opacity: 1
                }}
              >
                <img className="btn-icon-table" src={icons.eye} alt="icon" />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
